import { render } from "./App.vue?vue&type=template&id=a75173a6"
const script = {}

import "./App.vue?vue&type=style&index=0&id=a75173a6&lang=css"

import exportComponent from "/var/www/vhosts/pins/pinsv2/Pins_Queuing_System/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__